/**
 * Copyright (c) 2024, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { KissService, ValidationInfo } from "app/services/kiss.service";

@Injectable()
export class KissPortalValidationStateResolver implements Resolve<ValidationInfo> {

  constructor(
    private kissService: KissService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ValidationInfo> {
    // Get the 'ID' Path parameter which is the ID of the Service to obtain...
    const id = route.paramMap.get('id');
    console.log(`Obtaining State for ID: '${id}'...`);
    
    if (id == null || id.length == 0) {
      return null;
    }

    return await this.kissService.getValidationInfo(id).toPromise();
  }

}
